<template>
	<v-container>
		<v-row class="d-flex justify-center">
			<v-col cols md="12" class="">
				<h1 class="text-h4 font-weight-bold mb-5">Concursos Activos</h1>

				<!-- <v-simple-table>
					<template v-slot:default>
						<thead>
							<tr>
								<th class="text-uppercase">Encuesta</th>
								<th class="text-uppercase">Responder</th>
							</tr>
						</thead>
						<tbody>
							<tr v-for="item in getSurveys" :key="item.name">
								<td>{{ item.name }}</td>
								<td>
									<v-tooltip bottom color="rojo-obscuro">
										<template v-slot:activator="{ on, attrs }">
											<v-btn
												class="ma-1"
												outlined
												x-small
												fab
												color="green darken-3"
												v-bind="attrs"
												v-on="on"
												:href="`/encuestas/satisfaccion/${item.title}`">
												<v-icon>mdi-pencil</v-icon>
											</v-btn>
										</template>
										<span class="font-weight-bold"> Responder </span>
									</v-tooltip>
									<v-tooltip bottom color="verde-obscuro">
										<template v-slot:activator="{ on, attrs }">
											<v-btn
												class="ma-1"
												outlined
												x-small
												fab
												color="red darken-3"
												v-bind="attrs"
												v-on="on"
												:href="`/encuestas/satisfaccion/${item.title}`">
												{{ item.answers.length }}
											</v-btn>
										</template>
										<span class="font-weight-bold">
											{{ item.answers.length }} Participaciones
										</span>
									</v-tooltip>
								</td>
							</tr>
						</tbody>
					</template>
				</v-simple-table> -->
			</v-col>
		</v-row>
	</v-container>
</template>

<script>
	//import wsSurveys from "@/services/api-survey";

	export default {
		name: "Home",

		components: {},

		data: () => ({
			//getSurveys: {
			//imageCover: {},
			//author: {},
			//},

			meta: {
				cookie_time: process.env.VUE_APP_COOKIE,
				app_name: process.env.VUE_APP_NAME,
				base_url: process.env.VUE_APP_BASE_URL,
				endpoint: process.env.VUE_APP_ENDPOINT,
				storage_files: process.env.VUE_APP_STORAGE_FILES,
			},
		}),

		mounted() {
			//this.loadSurveys(this.currentSurveys);
		},

		methods: {
			loadSurveys() {
				wsSurveys.getCategories().then(
					(response) => {
						this.getSurveys = response.data.data;
						//console.log("🚀 ~ loadSurveys ~ this.getSurveys:", this.getSurveys);
						// console.log("✔✔");
					},
					(error) => {
						this.getSurveys =
							(error.response && error.response.data) ||
							error.message ||
							error.toString();
					}
				);
			},
		},
	};
</script>
